import { render, staticRenderFns } from "./KioskOrderV2.vue?vue&type=template&id=2467f8bc&scoped=true"
import script from "./KioskOrderV2.vue?vue&type=script&lang=js"
export * from "./KioskOrderV2.vue?vue&type=script&lang=js"
import style0 from "./KioskOrderV2.vue?vue&type=style&index=0&id=2467f8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2467f8bc",
  null
  
)

export default component.exports